module.exports = __webpack_public_path__ + "img/Fernando_de_la_Rosa.fe1ae686.jpg";